import Image from "next/image"

const animals = [
  { image: "/icons/dog.webp", name: "Dogs" },
  { image: "/icons/cat.webp", name: "Cats" },
  { image: "/icons/horse.webp", name: "Horses" },
  { image: "/icons/rabbit.webp", name: "Rabbits" },
  { image: "/icons/reptile.webp", name: "Reptiles" },
  { image: "/icons/rodent.webp", name: "Rodents" },
  { image: "/icons/bird.webp", name: "Birds" },
  { image: "/icons/fish.webp", name: "Fish" },
  { image: "/icons/livestock.webp", name: "Livestock" },
]

export default function PetTransportAnimals() {
  return (
    <section className="w-full mx-auto max-w-[1024px] pt-0">
      <h4 className="mb-10 text-2xl text-blue5 text-center font-semibold font-montserrat">
        Types of animals and pets we transport
      </h4>
      <section className="flex flex-wrap justify-center gap-x-14 gap-y-9">
        {animals.map(({ image, name }, i) => (
          <figure
            className="flex items-center space-x-2.5 mb-7 mx-auto"
            key={`PetTransportAnimals/figure/${i}`}
          >
            <Image
              className="object-contain"
              src={image}
              alt="dog profile"
              width={48}
              height={48}
            />
            <figcaption className="text-xl font-semibold font-montserrat">
              {name}
            </figcaption>
          </figure>
        ))}
      </section>
    </section>
  )
}
